import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {ISignUp} from '../../shared/interfaces/sign-up';
import {environment} from '../../../environments/environment';

import {Observable} from 'rxjs';
import {map} from 'rxjs/internal/operators';

@Injectable()
export class AuthService {

  constructor(private httpClient: HttpClient) {
  }

  signUp(signUp: ISignUp): Observable<{ message: string }> {
    const url = `${environment.awairAccountHost}users`;

    return this.httpClient
      .post<{ message: string }>(url, signUp);
  }

  requestDeveloperToken(orgToken: string): Observable<string> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${orgToken}`});
    const url = `${environment.awairAfbHost}orgs/self/developer/token`;

    return this.httpClient
      .get<{ token: string }>(url, {headers: headers})
      .pipe(
        map(response => response.token)
      );
  }
}
